<template>
	<modal
		v-if="isShow"
		class="coupon-editor-modal"
		size="medium"
		@close="close"
	>
		<div slot="header">
			<h3>
				<!-- <i class="material-icons">delete</i> -->
				<span>Update Features</span>
			</h3>
		</div>
		<div slot="body">
			<user-features :show-identity-card="false" :user="user" :type="type" @updateUser="updateUser" />
		</div>
	</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import UserFeatures from '@/components/UserFeatures.vue';

export default {
	props: {
		user: {
			type: Object,
			default: () => ({}),
		},
		isShow: {
			type: Boolean,
			default: () => false,
		},
		type: {
			type: String,
			default: 'all',
		},
	},
	components: {
		Modal,
		UserFeatures,
	},
	methods: {
		close() {
			this.$emit('close');
		},
		updateUser(val) {
			this.$emit('updateUser', val);
		},
	},
};
</script>

<style></style>
